import React, { useState, useEffect } from 'react';
import { makeSelectForm } from '../../../store/form/form.selectors';
import { useDispatch, useSelector } from 'react-redux';
import { Field, reduxForm, reset, initialize } from 'redux-form';
import { InputFieldComponent } from '../../atoms/atoms.index';
import { required, isEmail } from '../../../utils/FormValidators';
import { FormattedMessage } from 'react-intl';
import {
  ImageUploaderComponent,
  NavigationMenuComponent,
  NavbarComponent,
} from '../../organisms/organisms.index';
import { returnNotification } from '../../../store/render-controller/render-controller.actions';
import { ENotification } from '../../../domain/notification.interface';
import { makeSelectCurrentUser } from '../../../store/current-user/current-user.selectors';
import {
  getCurrentUser,
  editCurrentUser,
} from '../../../store/current-user/current-user.actions';
import { IUser } from '../../../domain/user.interface';
import './PersonalPage.component.scss';
import { ERoutes } from '../../../assets/constants/routes';

function PersonalPageComponent(props: any) {
  const [trigger, setTrigger] = useState(false);
  const [images, setImages] = useState<any>({});
  const dispatch = useDispatch();
  const form = useSelector(makeSelectForm());
  const currentUser: IUser = useSelector(makeSelectCurrentUser());

  useEffect(() => {
    dispatch(getCurrentUser());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(initialize('personalPageForm', currentUser));
    // eslint-disable-next-line
  }, [currentUser]);

  function handleResetForm(e: any) {
    e.preventDefault();
    dispatch(
      returnNotification({
        type: ENotification.WARNING,
        msg1: 'warning.confirmation.message',
        dispatch: { func: reset, param: ['personalPageForm'] },
        cb: { func: props.history.push, param: ERoutes.HOME },
      }),
    );
  }

  const checkErrors = () => {
    return form.personalPageForm.syncErrors ? true : false;
  };

  function handleEditCurrentUser(values: IUser, imgs: any) {
    if (checkErrors()) {
      setTrigger(true);
      return;
    }
    dispatch(editCurrentUser(values, imgs));
    props.history.push(ERoutes.HOME);
  }

  function handleNewImages(body: any, name: string) {
    const newImage = images;
    newImage[name] = body;
    setImages(newImage);
  }

  return (
    <div className='personal-page-container page-container'>
      <div>
        <NavbarComponent />
        <NavigationMenuComponent {...props} />
      </div>
      <div className='personal-page-form-container'>
        <form
          onSubmit={props.handleSubmit((values: IUser) =>
            handleEditCurrentUser(values, images),
          )}
        >
          <div>
            <h4 className='subtitle'>
              <FormattedMessage id='pages.personal_page.user_photo.title' />
            </h4>
            <div>
              <ImageUploaderComponent
                name='user_photo'
                handleNewImages={handleNewImages}
                maxNumImg={1}
                propsImages={currentUser.userPhoto}
              />
            </div>
          </div>
          <div>
            <h4 className='subtitle'>
              <FormattedMessage id='common.username' />
            </h4>
            <Field
              name={'nickname'}
              component={InputFieldComponent}
              validate={[required]}
              label={currentUser.nickname}
              errorTrigger={trigger}
              input={{ disabled: true }}
            />
          </div>
          <div>
            <h4 className='subtitle'>
              <FormattedMessage id='common.name-surname' />
            </h4>
            <FormattedMessage id='pages.personal_page.name.placeholder'>
              {(txt: any) => (
                <Field
                  name={'name'}
                  component={InputFieldComponent}
                  validate={[required]}
                  label={txt}
                  errorTrigger={trigger}
                />
              )}
            </FormattedMessage>
          </div>
          <div>
            <h4 className='subtitle'>
              <FormattedMessage id='pages.personal_page.email.title' />
            </h4>
            <div>
              <Field
                name={'email'}
                component={InputFieldComponent}
                validations={[required, isEmail]}
                label={currentUser.email}
                errorTrigger={trigger}
                input={{ disabled: true }}
              />
            </div>
          </div>
          <section className='form-button-container mt-4'>
            <div className='left-wfc'>
              <button
                className='btn-lili danger'
                onClick={(e: any) => handleResetForm(e)}
              >
                <FormattedMessage id='common.cancel' />
              </button>
            </div>
            <div className='right-wfc'>
              <button className='btn-lili' type='submit'>
                <FormattedMessage id='common.save' />
              </button>
            </div>
          </section>
        </form>
      </div>
    </div>
  );
}

export default reduxForm({
  form: 'personalPageForm',
})(PersonalPageComponent);
